import React, { useEffect, useState } from "react";
import NudgeModal from "../../../HtmlElements/NudgeModal";
import { 
  displayFormattedDate,
  getUserStatsObject,
  recordActivity,
  getUrlDetailsObj,
  getTabType
} from "../../../../services/commonService";
import { Accordion } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import RelevanceScore from "../../../HtmlElements/RelevanceScore";
import { useParams, useLocation } from "react-router-dom";


export default function NudgesTiles({ activeUnitNudges, is_side_card, activeAccordion, setActiveAccordion, selectedItems, setSelectedItems, activeUnit }) {

  const { accountId, accountName } = useParams();
  const [copied, setCopied] = useState(false);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [nudgeModalData, setNudgeModalData] = useState([]);

  var pageParsedData = getUrlDetailsObj(useLocation, useParams);
  pageParsedData.query_params = {}
  pageParsedData.query_params.tab = 'business';
  var tab_name = getTabType('business') || "";

  const handleAccordionClick = (index) => {
    setActiveAccordion(!activeAccordion.toString()); //Close the currently open accordion if cliked it
    let categoryName = activeUnitNudges[activeAccordion]?._id.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");

    let userStat = getUserStatsObject(
      tab_name+" - "+categoryName,
      "nudge_collapse",
      "Page Source: " + accountName,
      window.location.href,
      accountId
    );
    userStat.url_details = pageParsedData;
    recordActivity(userStat);

    if(activeAccordion.toString() !== index.toString()){
      categoryName = activeUnitNudges[index]?._id.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
      let userStat = getUserStatsObject(
        tab_name+" - "+categoryName,
        "nudge_expand",
        "Page Source: " + accountName,
        window.location.href,
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
      setActiveAccordion(index.toString()); // Open newly clicked accordion
    }
  };

  const handleCheckboxChange = (nudgeId) => {
    setSelectedItems((prevSelectedItems) =>
      prevSelectedItems.includes(nudgeId)
        ? prevSelectedItems.filter((id) => id !== nudgeId)
        : [...prevSelectedItems, nudgeId]
    );
  };

  const handleCopyToClipboard = () => {
    let userStat = {};
    const textToCopy = selectedItems
      .map((id) => {
        const nudge = activeUnitNudges.find((nudge) =>
          nudge.data.some((dataItem) => {
            return dataItem.id === id;
          })
        );

        let userStat = getUserStatsObject(
          tab_name+" - "+activeUnit,
          "nudge_copy",
          "Page Source: " + accountName,
          window.location.href,
          accountId
        );
        userStat.url_details = pageParsedData;
        recordActivity(userStat);
        const dataItem = nudge?.data.find((dataItem) => dataItem.id === id);

        return dataItem
          ? (dataItem?.title ? dataItem.title + "\n" : "") + dataItem?.nudge
          : "";
      })
      .join("\n\n");

    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
    });

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const handleMore = (nudgeData) => {
    setShowMoreModal(true);
    setNudgeModalData(nudgeData);
  };

  const handleClose = () => {
    setShowMoreModal(false);
  };

  return (
    <>
      <div className="copy_btn_block">
        <span
          className={`copy-message ${
            copied ? "copy-fade-in" : "copy-fade-out"
          }`}
        >
          Copied to clipboard!
        </span>

        <button
          disabled={selectedItems.length === 0}
          className="copy_btn"
          onClick={handleCopyToClipboard}
        >
          <img src="/img/icons/copy.png" alt="logo" width="20" className="" />{" "}
          Copy <span>{selectedItems.length}</span> Items
        </button>
      </div>
      
      {activeUnitNudges.map((buNudge, index) =>
        is_side_card === true ? (
            <div className="grow_nudges" key={index} id={buNudge?._id}>
              <h5 className="grow_nudges_head">
                {buNudge?._id
                  .split("_")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")}
              </h5>
              <div className="row">
                {buNudge?.data &&
                  buNudge?.data?.map((nudge, index_2) => (
                    <div className="col-md-6" key={index_2}>
                      <div className={`nudges_subblock ${nudge?.relevance_score >= 9 ? 'custom_active' : '' } `}>
                        <div className="checkbox_block">
                          <Form.Check
                            aria-label="option 1"
                            onChange={() => handleCheckboxChange(nudge.id)}
                            checked={selectedItems.includes(nudge.id)}
                          />
                        </div>
                        <div className="content_ndges">
                          <div className="content_para">
                            {nudge?.title && (
                              <h5 className="content_main_head">
                                {nudge?.title}
                              </h5>
                            )}
                            <div className="content_nudges_para">
                              {nudge.nudge}
                            </div>
                            <div className="date_company_impact_block">
                              {nudge?.relevance_score && (
                                <div className="impact_company_block">
                                 <div className='impact_score'>
                                  {nudge?.relevance_score ? <RelevanceScore relevanceScore={nudge?.relevance_score} section="impact_score" /> : ''}                                 
                               </div>
                               </div>
                            
                              )}
  
                              {nudge?.published_date && (
                                <span className="date_italic">
                                  {/* <b className="mr-1">Date: </b> */}
                                  {" "}
                                  {displayFormattedDate(
                                    nudge.published_date,
                                    "YYYY-MM-DD",
                                    true
                                  )}
                                </span>
                              )}
                            </div>

                           
                            {/* {nudge?.nudge && (
                              <p
                                className="show_more"
                                onClick={() => handleMore(nudge)}
                              >
                                <i
                                  className="fa fa-ellipsis-h"
                                  aria-hidden="true"
                                ></i>
                              </p>
                            )} */}
                          </div>
                        </div>
                        {nudge?.relevance_score >= 9 &&  <div className="contet_head_img">
                          <img
                            src="/img/icons/trending-up_backcolor.png"
                            alt="image"
                            className="image_block"
                          />
                        </div>
                        }
                      </div>
                    </div>
                  ))}
              </div>
            </div>
        ) : (
          <Accordion
            // defaultActiveKey={activeAccordion.toString()}
            activeKey={activeAccordion.toString()}
            key={index}
            className="custom_accordian"
          >
            <Accordion.Item eventKey={index.toString()} key={index}>
              <Accordion.Header onClick={() => handleAccordionClick(index)}>
                <h6 className="accordian_head">
                  <img
                    src="/img/icons/zap_green.png"
                    alt="logo"
                    width="16"
                    className="mr-2"
                  />
                  {buNudge?._id
                    .split("_")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                </h6>
              </Accordion.Header>
              <Accordion.Body>
                <div className="row">
                  <div className="clearfix"></div>
                  {buNudge.data.map((nudge, index_2) => (
                    <div className="col-md-6" key={index_2}>
                      <div className={`nudges_subblock ${nudge?.relevance_score >= 9 ? 'custom_active' : '' } `}>
                        <div className="checkbox_block">
                          <Form.Check
                            aria-label="option 1"
                            onChange={() => handleCheckboxChange(nudge.id)}
                            checked={selectedItems.includes(nudge.id)}
                          />
                        </div>
                        <div className="content_ndges">
                          <div className="content_para">
                            <div className="content_nudges_para">
                              {nudge?.title && (
                                <h5 className="content_main_head">
                                  {nudge?.title}
                                </h5>
                              )}
                                    <div className="nudges_para_custom">
                            
                            {nudge.nudge}
                          </div>
                          <div className="date_company_impact_block">
                            <div className="impact_company_block">
                              <div className="impact_score">
                              {nudge?.relevance_score ? <RelevanceScore relevanceScore={nudge?.relevance_score} section="impact_score" /> : ''}
                                </div>
                              </div>
                              {nudge?.published_date && (
                                  <span className="date_italic">
                                    
                                    {displayFormattedDate(
                                      nudge.published_date,
                                      "YYYY-MM-DD",
                                      true
                                    )}
                                    {/* &nbsp;<span>·</span> */}
                                  </span> 
                                )} 
                          </div>

                        
                            </div>
                            {/* {nudge?.nudge && (
                              <p
                                className="show_more"
                                onClick={() => handleMore(nudge)}
                              >
                                <i
                                  className="fa fa-ellipsis-h"
                                  aria-hidden="true"
                                ></i>
                              </p>
                            )} */}
                          </div>
                        </div>
                        {nudge?.relevance_score >= 9 &&
                        <div className="contet_head_img">
                          <img
                            src="/img/icons/trending-up_backcolor.png"
                            alt="image"
                            className="image_block"
                          />
                        </div>
                        }
                      </div>
                    </div>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )
      )}

      {showMoreModal && (
        <NudgeModal nudgeData={nudgeModalData} handleClose={handleClose} />
      )}
    </>
  );
}
